function sendEvent(key,detail){
	document.dispatchEvent(new CustomEvent(key,{detail}))
}
export {sendEvent}
